import { CreaAnagraficaDelegatoRequest } from '@framework/api-client';
import { yup } from '@framework/validation';

export enum AddressBookUserOrigin {
  EU = 'EU',
  EXTRA = 'EXTRA',
}

export const AddressBookRecordSchema = yup
  .object({
    userOrigin: yup
      .string()
      .required()
      .oneOfEnum(AddressBookUserOrigin)
      .label('Provenienza Utente'),
    codiceFiscale: yup
      .string()
      .label('Codice Fiscale')
      .when('userOrigin', ([origin]: AddressBookUserOrigin[], schema) => {
        return origin === AddressBookUserOrigin.EU
          ? schema.required()
          : schema.notRequired().strip();
      }),
    email: yup
      .string()
      .label('E-Mail')
      .when('userOrigin', ([origin]: AddressBookUserOrigin[], schema) => {
        return origin === AddressBookUserOrigin.EXTRA
          ? schema.required()
          : schema.notRequired().strip();
      }),
    nome: yup.string().label('Nome').required(),
    cognome: yup.string().label('Cognome').required(),
    indirizzo: yup.string().label('Indirizzo').notRequired(),
    note: yup.string().label('Note'),
  })
  .required()
  .noUnknown();

export type AddressBookRecord = yup.InferType<typeof AddressBookRecordSchema>;

/**
 * Mappa un record dell'anagrafica delegati in una richiesta di creazione/modifica
 */
export function mapAddressBookToData(
  record: AddressBookRecord,
): CreaAnagraficaDelegatoRequest {
  return {
    codiceFiscale: record.codiceFiscale,
    cognome: record.cognome,
    email: record.email,
    indirizzo: record.indirizzo,
    nome: record.nome,
    note: record.note,
    flUtenteEstero: record.userOrigin === AddressBookUserOrigin.EXTRA,
  };
}
